import { Link, useLocation } from '@tanstack/react-router';
import { Briefcase, FileText, LayoutDashboard, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  BOTTOM_NAV_HEIGHT,
  MOBILE_NAV_ITEMS,
} from '../../constants/dashboard.constants';

const iconMap: Record<string, typeof LayoutDashboard> = {
  'layout-dashboard': LayoutDashboard,
  'file-text': FileText,
  settings: Settings,
  briefcase: Briefcase,
};

export function BottomNavigation() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 flex items-center justify-around bg-surface-card px-5 pb-6 pt-3"
      style={{ height: BOTTOM_NAV_HEIGHT }}
    >
      {MOBILE_NAV_ITEMS.map((item) => {
        const isActive =
          location.pathname === item.path ||
          (item.path !== '/dashboard' &&
            location.pathname.startsWith(item.path));
        const Icon = iconMap[item.icon] || LayoutDashboard;

        return (
          <Link
            key={item.key}
            to={item.path}
            className={`flex flex-col items-center gap-1 ${
              isActive ? 'text-accent-primary' : 'text-foreground-tertiary'
            }`}
          >
            <Icon className="h-5 w-5" />
            <span className="text-xs font-medium">{t(item.labelKey)}</span>
          </Link>
        );
      })}
    </nav>
  );
}
